module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Darkest-Minds-The.fa884eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Darkest-Minds-The.jpg
// module id = f2Aj
// module chunks = 0